import { gaClientIdToABCPattern } from '@cocolocala/coco-ab-testing';
import fetch from 'isomorphic-unfetch';
import qs from 'query-string';

import { logger } from '~/utils/loggerUtil';
import { getClientId } from '~/utils/measurementUtils';

import { GetConfigUtil, isServer } from '../shared/utils/envUtil';
import { LoggingLabel } from './constants';

const ENV_CONFIG = GetConfigUtil.getPublicStaticConfig();

export const sendSimpleLog = (
  label: LoggingLabel,
  version: string,
  userId: string = '',
  firebaseUid: string = '',
  customParams: object = {}
) => {
  return sendLog('GET', label, version, userId, firebaseUid, customParams);
};

export const sendOrderFormSubmitLog = (
  label: LoggingLabel,
  cocolocalaUserId: string = '',
  firebaseUid: string = '',
  errors: string = ''
) => {
  return sendLog('GET', label, 'v1', cocolocalaUserId, firebaseUid, {
    clientId: getClientId(),
    errors: errors,
    abPattern: gaClientIdToABCPattern(getClientId()),
  });
};

export const sendOrderFormInputLog = (
  label: LoggingLabel,
  type: 'text' | 'select',
  valueLength?: number
) => {
  return sendLog('GET', label, 'v1', '', '', {
    clientId: getClientId(),
    valueLength: valueLength,
    type: type,
    abPattern: gaClientIdToABCPattern(getClientId()),
  });
};

const sendLog = (
  requestType: 'GET' | 'POST',
  label: LoggingLabel,
  version: string,
  userId: string = '',
  firebaseUid: string = '',
  customParams: object = {}
) => {
  const defaultParams = {
    label: label,
    version: version, // log version
    prd_id: 'cw', // product id (cocolocala-web の頭文字)
    user_id: userId || '',
    fb_uid: firebaseUid || '',
    client_time: new Date().toISOString(), // cacheされない役目を兼ねる
    is_server: isServer,
    url: window ? window.location.href : '',
    ua: window ? window.navigator.userAgent : '',
  };
  const params = Object.assign(defaultParams, customParams);
  logger.debug(params);

  if (requestType === 'GET') {
    return fetch(ENV_CONFIG.LOGGING_ANY_URL + '?' + qs.stringify(params), {
      mode: 'cors',
      headers: {
        'Meta-Log-Type': 'any',
      },
    });
  } else {
    return fetch(ENV_CONFIG.LOGGING_ANY_URL, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Meta-Log-Type': 'any',
        Accept: 'application/json',
        'Content-type': 'application/json',
      },
      body: JSON.stringify(params),
    });
  }
};
